import { Component, OnInit } from '@angular/core';
import { ApiserviceService } from '../apiservice.service';
import { AuthdataService } from '../authdata.service';





@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {


  isLogin:boolean=false;


  logoutclick(){
    localStorage.removeItem("Token")
    location.reload();


  }


  constructor(private _AuthdataServiceL:AuthdataService, private _ApiserviceService:ApiserviceService) { 


_AuthdataServiceL.currenttoken.subscribe((data)=> {
  if (data == null){
    this.isLogin=false;
  }else {
    this.isLogin=true;
    
  }
})














}

  ngOnInit(): void {
  }






}
